/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSubscript = createReactComponent("subscript", "IconSubscript", [
  ["path", { d: "M5 7l8 10m-8 0l8 -10", key: "svg-0" }],
  ["path", { d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2", key: "svg-1" }]
]);

export { IconSubscript as default };
//# sourceMappingURL=IconSubscript.js.map
